import React from "react";
import { Button, Grid, TextField } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { validate as validateRut } from "rut.js";
import { isValidPhoneNumber } from "react-phone-number-input";
import AuthService from "../../../../services/auth.service";
import { useAlert } from "react-alert";
import PulseLoader from "react-spinners/PulseLoader";
import { colors } from "../../../../assets/theme";
import { constantsApp } from "../../../../constants/constants.app";

const residentSchema = Yup.object().shape({
  name: Yup.string().required(
    constantsApp.components.forms.community.worker.workerSchema.REQUIRED
  ),
  lastName: Yup.string().required(
    constantsApp.components.forms.community.worker.workerSchema.REQUIRED
  ),
  id: Yup.string().required(
    constantsApp.components.forms.community.worker.workerSchema.REQUIRED
  ),
  email: Yup.string()
    .email()
    .required(
      constantsApp.components.forms.community.worker.workerSchema.REQUIRED
    ),
  phone: Yup.string().required(
    constantsApp.components.forms.community.worker.workerSchema.REQUIRED
  )
});

const initialValues = {
  name: "",
  lastName: "",
  id: "",
  email: "",
  phone: "",
  password: "",
  role: "worker"
};

export default function CreateForm({ onCancel }) {
  const alert = useAlert();
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={residentSchema}
      validate={({ id, phone }) => {
        let errors = {};
        if (!validateRut(id)) {
          errors.id =
            constantsApp.components.forms.community.worker.workerSchema.INVALID_ID;
        }
        if (!isValidPhoneNumber(phone)) {
          errors.phone =
            constantsApp.components.forms.community.worker.workerSchema.INVALID_PHONE;
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        const newValues = { ...values };
        AuthService.createUser(newValues)
          .then(community => {
            resetForm(initialValues);
            setSubmitting(false);
            alert.show("Registro exitoso!", { type: "success" });
          })
          .catch(err => {
            setSubmitting(false);
            alert.show(err.message, { type: "error" });
          });
      }}
    >
      {({ errors, handleChange, handleSubmit, values, isSubmitting }) => {
        if (isSubmitting)
          return (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ height: 200 }}
            >
              <PulseLoader color={colors.LOADING} />
            </Grid>
          );
        return (
          <form onSubmit={handleSubmit}>
            <TextField
              id="id"
              onChange={handleChange}
              value={values.id}
              variant="outlined"
              margin="dense"
              fullWidth
              type="text"
              label={
                constantsApp.components.forms.community.worker.textField.ID_LBL
              }
              helperText={errors && errors.id}
            />
            <TextField
              id="name"
              onChange={handleChange}
              value={values.name}
              variant="outlined"
              margin="dense"
              fullWidth
              type="text"
              label={
                constantsApp.components.forms.community.worker.textField
                  .NAME_LBL
              }
              helperText={errors && errors.name}
            />
            <TextField
              id="lastName"
              onChange={handleChange}
              value={values.lastName}
              variant="outlined"
              margin="dense"
              fullWidth
              type="text"
              label={
                constantsApp.components.forms.community.worker.textField
                  .LAST_NAME_LBL
              }
              helperText={errors && errors.lastName}
            />
            <TextField
              id="email"
              onChange={handleChange}
              value={values.email}
              variant="outlined"
              margin="dense"
              fullWidth
              type="email"
              label={
                constantsApp.components.forms.community.worker.textField
                  .EMAIL_LBL
              }
              helperText={errors && errors.email}
            />
            <TextField
              id="phone"
              onChange={handleChange}
              value={values.phone}
              variant="outlined"
              margin="dense"
              fullWidth
              type="text"
              label={
                constantsApp.components.forms.community.worker.textField
                  .PHONE_LBL
              }
              helperText={errors && errors.phone}
            />
            <TextField
              id="password"
              onChange={handleChange}
              value={values.password}
              variant="outlined"
              margin="dense"
              fullWidth
              type="password"
              label={
                constantsApp.components.forms.community.worker.textField
                  .PASSWORD_LBL
              }
              helperText={errors && errors.email}
            />
            <Grid container justify="center">
              <Button
                onClick={() => {
                  onCancel("showForm");
                  onCancel("showFormWorker");
                }}
                variant="contained"
                color="secondary"
                size="large"
              >
                {constantsApp.butons.CANCEL}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
              >
                {constantsApp.butons.DONE}
              </Button>
            </Grid>
          </form>
        );
      }}
    </Formik>
  );
}
